import * as React from 'react';

import { isExternalLink } from '@coursera-web/shared-articles';

import { Link } from '@coursera/cds-core';

import { TrackedA } from 'bundles/page/components/TrackedLink2';

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement>;

const TutorialLink = ({ href, children }: Props) => {
  if (!href) {
    return null;
  }
  return !isExternalLink(href) ? (
    <Link component={TrackedA} href={href} trackingName="tutorial_body_link">
      {children}
    </Link>
  ) : (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};

export default TutorialLink;
